module.exports = __webpack_public_path__ + "static/media/janetWagner.3fe16a7a.jpg";